module.exports = __webpack_public_path__ + "static/media/tempe.09f81b56.jpg";